import persianToEnglish from './persian-to-english-number';

const validMobileNumber = (mobileNumber: string) => {
  mobileNumber = persianToEnglish(mobileNumber);

  const pattern = /^(0|0098|\+98|98)9\d{9}$/g;
  const isValid = pattern.test(mobileNumber);
  const mobile = isValid ? mobileNumber.slice(-10) : null;

  return {
    isValid: isValid,
    mobile: mobile,
  };
};

export default validMobileNumber;
